module.exports = __webpack_public_path__ + "img/pr-4.3647c684.png";